import React, { Component } from 'react';
import DashboardHeading from '../commonFiles/DashboardHeading';
import NewEventPopup from './NewEventPopup';
import CalendarDates from './pages/CalendarDates';
import HolidayList from './calendarPages/HolidayList';
import EventList from './calendarPages/EventList';
import LeaveEmpList from './calendarPages/LeaveEmpList';
import './pages/Calendar.css';
import $ from "jquery";
import axios from 'axios';
class Calendar extends Component {
  constructor() {
    super();
    this.state = {
      calendar_view:'',
      month_list:[],
      year_list:[],
      user_type:0,
      messagePopup:'',
      addNewEventPopup:'',
      event_month_view:'',
      holiday_view:'',

    };
  }

componentDidMount(){
  this.get_month_calendar_view();
}

get_month_calendar_view(){
  let cutThis = this;
  var web_token = $('#web_token').val();
   var body = new FormData();
   body.append('web_token',web_token);
   body.append('function','get_month_calendar_data');
   var url      = '';
   if(window.location.host ==="localhost:3000"){
     url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
   }else{
     url = "/php/admin_free_consultation_url.php";
   }
   axios({
        method: 'POST',
        url: url,
        data: body
    })
    .then(function (res) {
      var data = res.data;
      if(data['code']==1){
        var msg   = data['msg'];
        var year  = data['msg']['year'];
        var month = data['msg']['month'];
        var user_type = data['user_type'];
        var event_month = data['event_month'];
        var holiday = data['holiday'];
        var event_month_view = <EventList event_month={event_month}/>;
        var holiday_view = <HolidayList event_month={holiday}/>;

        cutThis.setState({event_month_view});
        cutThis.setState({holiday_view});
        cutThis.setState({user_type});
        cutThis.create_month_year_opt_list(month,year);
        var calendar_view = <CalendarDates all_dates_data={msg} event_month={event_month} holiday={holiday}/>;
        cutThis.setState({calendar_view});
      }else{
        //window.location.href = '/';
      }

    })
    .catch(function (error) {
        console.log(error);
    });
}




create_month_year_opt_list(month,year){
  var month_list = [];
  var year_list = [];
  var new_year = Number(year)+1;
  for(var y=2025;y<=new_year;y++){
    year_list.push(
      <option value={y}>{y}</option>
    );
  }
  this.setState({year_list});
  var month_array = [ "", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  for(var m=1; m<month_array.length; m++){
    var month_name = month_array[m];
    month_list.push(
      <option value={m}>{month_name}</option>
    );
  }
  this.setState({month_list});
  setTimeout(function (){
    var month_new = parseInt(month);
    $('#calendar_month').val(month_new);
    $('#calendar_year').val(year);
  },100);
}
schedule_consultation(){
  var addNewEventPopup = <NewEventPopup close_popup_view={this.close_popup.bind(this)}/>;
  this.setState({addNewEventPopup});
  setTimeout(function (){window.model_show();},100);
}

close_popup(){
  window.model_hide();
  var addNewEventPopup = '';
  this.setState({addNewEventPopup});
}


change_month_view(){
  let cutThis = this;
  var month = window.isNullAndUndef($('#calendar_month').val());
  var year  = window.isNullAndUndef($('#calendar_year').val());
  var web_token = window.isNullAndUndef($('#web_token').val());
  $('label').removeClass('color_red');
  if(month && year && web_token){
    var body = new FormData();
    body.append('year',year);
    body.append('month',month);
    body.append('web_token',web_token);
    body.append('function','get_selected_month_calendar_data');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
    }else{
      url = "/php/admin_free_consultation_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
        var data = res.data;
        if(data['code']==1){
          var calendar_view = '';
          cutThis.setState({calendar_view});
          var msg   = data['msg'];
          var year  = data['msg']['year'];
          var month = data['msg']['month'];
          var user_type = data['user_type'];
          cutThis.setState({user_type});
          setTimeout(function (){
            calendar_view = <CalendarDates all_dates_data={msg}/>;
            cutThis.setState({calendar_view});
        }.bind(cutThis),100);

        }else{
          //window.location.href = '/';
        }
     })
     .catch(function (error) {
         console.log(error);
     });
  }else{
    window.change_lable_color('calendar_month','calendar_year');
  }
}
  render() {
    return (
        <>
        <DashboardHeading title="Calendar"/>
        <div className="container mt-4 mb-4 calendar_main_div">
              <h3 className="wow fadeInUp" data-wow-delay="0.1s">Calendar</h3>

        <div class="calendar_navigator clearfix">
        <div className="row g-3 mb-2">
        <div className="col-md-2">
            <div className="form-floating">
                <select class="form-control form-select" id="calendar_month" name="calendar_month" onChange={this.change_month_view.bind(this)}>
                <option value="">Month</option>
                {this.state.month_list}
            </select>
            <label for="name">Month</label>
            </div>
        </div>
        <div className="col-md-2">
            <div className="form-floating">
                <select class="form-control form-select" id="calendar_year" name="calendar_year" onChange={this.change_month_view.bind(this)}>
                <option value="">Year</option>
                {this.state.year_list}
            </select>
            <label for="name">Year</label>
            </div>
            </div>
            <div className="col-md-3">
              <button className="btn btn-primary w-100 py-3" type="button" onClick={this.schedule_consultation.bind(this)}>New Event</button>
            </div>
        </div>

        </div>

        <div class="container-fluid-1 cearfix clearfix_1" id="weekly_calendar">
          <div class="columns clearfix">
            <div class="event-column clearfix">
              <header class="calendar_headings clearfix">
                <div class="weekdays clearfix">
                  <div class="weekend calendar_heading">Sunday</div>
                  <div class="weekday calendar_heading">Monday</div>
                  <div class="weekday calendar_heading">Tuesday</div>
                  <div class="weekday calendar_heading">Wednesday</div>
                  <div class="weekday calendar_heading">Thursday</div>
                  <div class="weekday calendar_heading">Friday</div>
                  <div class="weekend calendar_heading">Saturday</div>
                </div>
              </header>
              { this.state.calendar_view }
            </div>

            </div>
          </div>

          {this.state.addNewEventPopup}
          <div className="row g-3 mb-2">
          {this.state.holiday_view}
          {this.state.event_month_view}
          <LeaveEmpList/>
          </div>
  </div>
        </>
    );
  }
}

export default Calendar;
